// @noflow
import { applyMiddleware, compose, createStore } from 'redux';

import { createLogger } from 'redux-logger';
import createReducer from './';
import createSagaMiddleware from 'redux-saga';
import createTrackerMiddleware from '~/middleware/tracking';
import { identity } from 'lodash/fp';
import sagas from '~/core/state/sagas-registration';
import thunk from 'redux-thunk';
import timestampMiddleware from '~/middleware/timestamp';
import trackers from './trackers-registration';
import Raven from 'raven-js';

global.myData = {};

const logSagaErrors = e => global.console.log(e);

const sagaMiddleware = createSagaMiddleware({
    onError: process.env.NODE_ENV === 'development' ? logSagaErrors : Raven.captureException.bind(Raven)
});

export default function configureStore(initialState) {
    let DevTools;
    const allowDevTools = process.env.REACT_APP_DEVTOOLS;
    const isProduction = process.env.NODE_ENV !== 'production';

    if (allowDevTools) {
        DevTools = require('<drivers>/dev-tools').default;
    }

    const trackerMiddleware = createTrackerMiddleware(global._satellite, global.myData);

    const middlewares = [
        thunk,
        sagaMiddleware,
        trackerMiddleware,
        timestampMiddleware,
        isProduction && createLogger({ collapsed: true })
    ].filter(identity);

    const enhancers = [applyMiddleware(...middlewares), allowDevTools && DevTools.instrument()].filter(identity);

    const enhancer = compose(...enhancers);
    const store = createStore(createReducer(), initialState, enhancer);

    // This will hold any reducers that are loaded at runtime in modules
    store.asyncReducers = {};

    if (module.hot) {
        // Enable Webpack Hot Module Replacement for reducers
        module.hot.accept('./', () => {
            const nextCreateReducer = require('./').default;

            // If any core reducers change then reapply them with the
            // async ones loaded so far applied too.
            store.replaceReducer(nextCreateReducer(store.asyncReducers));
        });
    }

    createTrackerMiddleware.registerTrackers(trackers);
    sagaMiddleware.run(sagas);

    return store;
}

// This is called when a module has been asynchronously loaded and wants
// to add some new reducers
export function injectAsyncReducers(store, asyncReducers) {
    store.asyncReducers = {
        ...store.asyncReducers,
        ...asyncReducers
    };

    store.replaceReducer(createReducer(store.asyncReducers));
}

export function injectAsyncSagas(sagas) {
    sagas.forEach(sagaMiddleware.run);
}

export function injectAsyncTrackers(trackers) {
    createTrackerMiddleware.registerTrackers(trackers);
}



// WEBPACK FOOTER //
// ./src/core/state/store.js